import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { UwProspectsApi } from '../tokens/uw-prospects.token';
import {
  UwProspectConsistencyRequest,
  UwProspectConsistencyResponse,
  UwProspectDossier,
} from '../models/uw-prospect.model';

/**
 * REST implementation of {@link UwProspectsApi} — the ONE home of the `/v1/uw/prospects` endpoints
 * (EM-1548). Both UW prospect pages consume it through the `UW_PROSPECTS` token; neither wires
 * `HttpClient` itself (Rule 17).
 *
 * Errors are deliberately NOT caught here: the RFC-7807 body must reach the page's `error:` callback
 * so `extractBackendErrorMessage` can surface the backend's own message (Rule 09) — in particular the
 * `403 PROSPECT_VERDICT_FORBIDDEN` detail, which names the field that caused it.
 */
@Injectable({ providedIn: 'root' })
export class UwProspectsRestService implements UwProspectsApi {
  private http = inject(HttpClient);

  private readonly base = API_PATHS.UW_PROSPECTS;

  getDossier(prospectId: number): Observable<UwProspectDossier> {
    return this.http.get<UwProspectDossier>(`${this.base}/${prospectId}`);
  }

  recordConsistency(
    prospectId: number,
    request: UwProspectConsistencyRequest,
  ): Observable<UwProspectConsistencyResponse> {
    return this.http.post<UwProspectConsistencyResponse>(`${this.base}/${prospectId}/consistency`, request);
  }
}
